import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import source from "./components/source";
import path from "./components/path";
import receiver from "./components/receiver";

const principle: Slide = {
  description:
    "The basic principle behind BTPA is to measure and analyze the different transfer paths between the different sources of sound and the ears of the listener (represented by a binaural measurement system). For complex systems, with different possible sources, paths, and operating points, a large number of measurements are usually required.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [{ name: "Source" }, { name: "Path" }, { name: "Receiver" }],
        },
      ],
      controlsPosition: "bottom",
      extraContent: [[], [], []],
      components: [source, path, receiver],
    },
  },
};

export default principle;
